import React from 'react';
import sharkMascot from '../assets/shark_mascot.png';
import CoinDropCountdown from './Counter';
const Hero = () => {
  return (
    <section style={{
      textAlign: 'center',
      padding: '6rem 1rem',
      backgroundColor: '#1a202c',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '2rem'
    }}>
      <img src={sharkMascot} alt="SharkKid Mascot" style={{ width: '750px', borderRadius: '16px', height: 'auto' }} />
      <h2 style={{ fontSize: '3rem', margin: 0, color: '#63b3ed' }}>Dive into the World of SharkKid!</h2>
      <p style={{ fontSize: '1.2rem', maxWidth: '800px', color: '#cbd5e0' }}>
        Get ready for the next big wave in crypto! SharkKid is a new decentralized currency
        launching soon on **Pump.fun**. Join our community and be part of something legendary.
      </p>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <a href="https://t.me/+MwezxqE66qU4NGIx" target="_blank" rel="noopener noreferrer" className="btn">Join Telegram</a>
        <a href="https://x.com/SharkKidSK" target="_blank" rel="noopener noreferrer" className="btn">Follow on X</a>
      </div>
      <div style={{ marginTop: '2rem', backgroundColor: '#2d3748', padding: '1.5rem', borderRadius: '0.5rem', width: '80%', maxWidth: '600px' }}>
        <h3 style={{ color: '#63b3ed', marginBottom: '1rem' }}>Launch Information (Coming Soon!)</h3>
        <p style={{ color: '#cbd5e0' }}>
          **Pump.fun Link:** <span style={{ color: '#fc8181' }}>*Will be updated here once released*</span>
        </p>
        <p style={{ color: '#cbd5e0' }}>
          **Contract Address:** <span style={{ color: '#fc8181' }}>*Will be updated here once released*</span>
        </p>
        <p style={{ fontSize: '0.9rem', color: '#a0aec0' }}>
          Stay tuned to our social media channels for the official launch announcement!
        </p>
      </div>
    </section>
  );
};

export default Hero;